import axios from "axios";

export async function fetchMenu() {
  try {
    const response = await axios.get("https://api-automotive-demo.whappy.it/api/MenuManager/AppMenu");
    return response.data; 
  } catch (error) {
    console.error("Error fetching menu:", error);
    return []; 
  }
}
